import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function IntroSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="intro" className="pt-28 md:pt-40 pb-16 md:pb-20 px-6 md:px-12 lg:px-24" data-testid="intro-section">
      <div className="max-w-4xl mx-auto" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          <div className="flex items-center gap-4 mb-14">
            <div className="w-12 h-[1px] bg-gold" />
            <span className="text-gold text-[10px] tracking-[0.4em] uppercase font-body font-medium">
              About The Event
            </span>
          </div>

          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight uppercase mb-14 leading-[1.05]">
            A Celebration of{' '}
            <span className="text-gold">Sport & Culture</span>
          </h2>

          <div className="space-y-6">
            <p className="text-zinc-400 text-base md:text-lg leading-[1.8] font-body font-light">
              OZFEST brings the bold spirit of Australia to the heart of Las Vegas! An electrifying celebration of sport, culture, food, music, and innovation. Hosted at Resorts World during Rugby League's historic Vegas takeover, OZFEST is where global fans, world-class brands, and unforgettable live experiences collide.
            </p>
            <p className="text-zinc-500 text-base md:text-lg leading-[1.8] font-body font-light">
              From immersive fan zones and premium hospitality to iconic entertainment and high-energy moments, OZFEST delivers a one-of-a-kind event that captures the excitement, passion, and spectacle of international sport in Las Vegas.
            </p>
          </div>

          <div className="flex items-center gap-8 mt-16">
            <div className="flex-1 h-[1px] bg-gradient-to-r from-gold/30 to-transparent" />
            <div className="flex gap-3">
              {['Sport', 'Culture', 'Energy'].map((word) => (
                <span
                  key={word}
                  className="text-[10px] tracking-[0.3em] uppercase text-gold/60 font-body"
                >
                  {word}
                </span>
              ))}
            </div>
            <div className="flex-1 h-[1px] bg-gradient-to-l from-gold/30 to-transparent" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
